import request from '../../../api/request';
import {
  PetitionsHistoryResponse,
  PetitionsDetailResponse,
  ResponselinkedFile,
  Pagination,
} from '../parts/petitionsHistory/types';

const PETITIONS_HISTORY = {
  GET_PETITIONS_HISTORY: (studentId: string | number) =>
    `maintainers-portal/student-management/petitions-history/${studentId}`,
  GET_PETITION_DETAIL: (petitionId: number | string) =>
    `/maintainers-portal/student-management/petitions-history/petition/${petitionId}`,
  GET_STUDENT_PETITION_FILES: (fileId: number | string) =>
    `/maintainers-portal/student-management/petitions-history/file/${fileId}`,
};

export function getPetitionsHistory(studentId: number, pagination: Pagination) {
  const params = pagination;
  return request<PetitionsHistoryResponse>(
    PETITIONS_HISTORY.GET_PETITIONS_HISTORY(studentId),
    { params },
  );
}

export function getPetitionDetail(petitionId: number | string) {
  return request<PetitionsDetailResponse>(
    PETITIONS_HISTORY.GET_PETITION_DETAIL(petitionId),
  );
}

export function getPetitionStatusPdf(fileId: number | string) {
  return request<ResponselinkedFile>(
    PETITIONS_HISTORY.GET_STUDENT_PETITION_FILES(fileId),
  );
}
